import { Pipe, PipeTransform } from '@angular/core';
import { OrderService } from '../services/order.service';
import { DeliveryForDate } from '../api/contracts/order';
import { DeliveryForDateStatus } from '../types/delivery-for-date';

@Pipe({
  name: 'getDeliveryForDateStatus',
})
export class GetDeliveryForDateStatusPipe implements PipeTransform {
  constructor(private readonly orderService: OrderService) {}

  transform(deliveryItem: DeliveryForDate): DeliveryForDateStatus {
    return this.orderService.getDeliveryForDateStatus(deliveryItem);
  }
}
